

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'workunit',
      dataIndex: 'workunit',
      title: '单位',
      width: 200,
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '用户ID',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '姓名',
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '手机号',
    },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '编辑',
      width: 100,
      slot: 'operate1',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
